import ReactMapboxGl from "react-mapbox-gl";

const Map = ReactMapboxGl({
  accessToken:
    "pk.eyJ1IjoibWRpY2tzb24iLCJhIjoiY2w3a242dXpjMHN3dTN2bnMzaGg5azBuaiJ9.VC-uUxv6pYQyJV6m_TXTPA"
});

export default Map

 